module.exports = __webpack_public_path__ + "static/media/t1.b7525f6f.svg";